module.exports = __webpack_public_path__ + "assets/img/culture_img2.6857ac39.png";